<template>
  <div v-if="isWeightProduct()">
    <form
      action=""
      @submit.prevent="onSubmit"
      ref="form"
      class="
        d-flex
        flex-row
        p-2
        bg-gray-0
        rounded
        justify-content-start
        align-items-center
      "
    >
      <CInput
        :disabled="haveIncidentOpen() || isClosed()"
        size="sm"
        type="number"
        min="0"
        step="0.1"
        v-model="form.weight"
        :append="unit"
        :placeholder="$t('role.orders.manage.weightModal.weight')"
        style="min-width: 100px"
      >
      </CInput>
      <CButton
        :disabled="haveIncidentOpen() || isClosed()"
        color="primary"
        size="sm"
        class="ml-1"
        @click.prevent="onSubmit"
      >
        <font-awesome-icon icon="balance-scale" />
      </CButton>
      <CButton
        color="gray-500"
        size="sm"
        class="ml-1"
        :disabled="haveIncidentOpen() || isClosed()"
        @click.prevent="onWeightButton()"
      >
        <font-awesome-icon icon="comment" />
      </CButton>

      <font-awesome-icon
        icon="exclamation-triangle"
        class="text-warning ml-2"
        v-if="!isWeighed"
      />
      <font-awesome-icon icon="check-circle" class="text-success ml-2" v-else />
    </form>
  </div>
</template>

<script>
import get from "lodash/get";
import { getPriceUnitOptions } from "../../../../helpers/options";
import { getOptionLabel } from "../../../../helpers/common";
import EventBus from "../../../../helpers/EventBus";
import { apiPatch } from "../../../../helpers/apiHelper";

export default {
  name: "OrdersWeightButton",

  data() {
    return {
      isWeighed: false,
      unit: "",
      form: {
        weight: 0,
        msg: "",
      },
    };
  },

  components: {},

  props: {
    row: { type: Object, required: true },
    parentRowIndex: { required: true },
  },

  mounted() {
    this.initializeWeight();
  },

  methods: {
    onWeightButton() {
      const { parentRowIndex, row } = this;
      const entryData = { parentRowIndex, row };
      this.$store.commit("productWeight/openModal", {
        entryData,
      });
    },

    initializeWeight() {
      const currentWeight =
        get(this.row, "qta", 0) || get(this.row, "weight", 0);
      this.form.weight = currentWeight;

      this.unit = getOptionLabel(
        get(this.row, "ppm.lot.productproducer.pw_unit"),
        getPriceUnitOptions(this.$i18n)
      );

      this.isWeighed = !this.mustBeWeighed();
    },

    isWeightProduct() {
      return get(this.row, "ppm.lot.productproducer.pw", false);
    },

    mustBeWeighed() {
      return get(this.row, "need_w", false);
    },

    haveIncidentOpen() {
      return get(this.row, "incident.close") === false;
    },

    isClosed() {
      return get(this.row, "status") >= 200;
    },

    async onSubmit() {
      const payload = {
        lod_id: get(this.row, "id"),
        weight: this.form.weight,
        msg: this.form.msg,
      };

      const response = await apiPatch("role_order_pw", null, payload, []);

      if (response && response.status === 200) {
        this.isWeighed = true;

        this.$store.dispatch("toaster/add", {
          title: this.$t("user.profile.data.ok.title"),
          text: this.$t("user.profile.data.ok.message"),
          color: "success",
          autohide: true,
        });
      } else {
        console.error(response);
      }
    },
  },
};
</script>
